module.exports = __webpack_public_path__ + "static/img/authHistory.793e1df.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/products/software/wxMini/authHistory.jpg
// module id = Ae6C
// module chunks = 0